import dynamic from 'next/dynamic';

// CoreVideo (the mux player) is client-only (ssr: false), so without a
// same-sized placeholder the page renders with no space for it at all and
// then jumps once the player's chunk loads, pushing every <p> below it down.
// This mirrors CoreVideo's own wrapper/sizing exactly so the swap is a no-op.
const VideoPlaceholder = () => (
  <div className='w-full text-center'>
    <div className='mt-2 max-w-2xl mx-auto' style={{ aspectRatio: 16 / 9 }} />
  </div>
)

const Video = dynamic(() => import("./CoreVideo"), {
  ssr: false,
  loading: VideoPlaceholder,
})

export default Video